import { CITIZEN_PROFILE_URL } from 'constants/urls'

type CITIZEN_PROFILE_ROUTES_PARAMS = {
  [key: string]: any
}

export const CITIZEN_PROFILE_ROUTES: CITIZEN_PROFILE_ROUTES_PARAMS = {
  COMPANIES: '/perfil-cidadao/empresas',
  CITIZENS: '/perfil-cidadao/cidadaos',
  CITIZEN_PROFILE: '/perfil-cidadao/cidadaos/[citizenSlug]',
  COMPANY_PROFILE: '/perfil-cidadao/empresas/[companySlug]',
  FAMILIES: '/perfil-cidadao/familias',
  FAMILY_PROFILE: '/perfil-cidadao/familias/[familySlug]',
  IDENTITY_CARDS: '/perfil-cidadao/cartoes-de-identidade',
  ALERTS_VISUALIZATIONS: '/perfil-cidadao/visualizacoes-dos-alertas',
  CITIZENS_VISUALIZATIONS: '/perfil-cidadao/visualizacoes-dos-cidadaos',
  ACTIVITIES_VISUALIZATIONS: '/perfil-cidadao/visualizacoes-das-atividades',
  PUBLIC_AGENTS_PERMISSIONS: '/perfil-cidadao/permissoes-dos-agentes-publicos',
  GROUPS_PERMISSIONS: '/perfil-cidadao/permissoes-dos-grupos',
  DATA_HEALTH: '/perfil-cidadao/qualidade-dos-dados',
  FAMILY_PROFILE_GENERAL: {
    MEMBERS: '/perfil-cidadao/familias/[familySlug]/geral/membros',
    ORIGINS: '/perfil-cidadao/familias/[familySlug]/geral/origens',
    RESIDENCE: '/perfil-cidadao/familias/[familySlug]/geral/domicilio',
    ALERTS: '/perfil-cidadao/familias/[familySlug]/geral/alertas',
    ACTIVITIES: '/perfil-cidadao/familias/[familySlug]/geral/atividades',
    ASSESSMENTS: '/perfil-cidadao/familias/[familySlug]/geral/avaliacoes',
  },
  CITIZEN_PROFILE_GENERAL: {
    BASIC_INFORMATION: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ORIGIN_REGISTERS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ACTIVITIES: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ACTIVITIES_PERFORMED: '/perfil-cidadao/cidadaos/[citizenSlug]',
    PLANNING_ACTIVITIES: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ALERTS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    SERVICE_REQUESTS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    CASE_FOLLOW_UPS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ASSESSMENTS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    SURVEYS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    DOCUMENTS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    FILES: '/perfil-cidadao/cidadaos/[citizenSlug]',
    FAMILIES: '/perfil-cidadao/cidadaos/[citizenSlug]',
    TUTORS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ACTIONS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    ALERTS_MONITOR: '/perfil-cidadao/cidadaos/[citizenSlug]',
    REGISTERED_EVENTS: '/perfil-cidadao/cidadaos/[citizenSlug]',
    UPDATE_ACTIONS: '/perfil-cidadao/cidadaos/[citizenSlug]',
  },
  COMPANY_PROFILE_GENERAL: {
    BASIC_INFORMATION: '/perfil-cidadao/empresas/[citizenSlug]/geral/informacoes-basicas',
    ORIGIN_REGISTERS: '/perfil-cidadao/empresas/[citizenSlug]/geral/cadastros-origens',
    ACTIVITIES: '/perfil-cidadao/empresas/[citizenSlug]/geral/atividades',
    PLANNING_ACTIVITIES: '/perfil-cidadao/empresas/[citizenSlug]/geral/atividades-planejadas',
    ALERTS: '/perfil-cidadao/empresas/[citizenSlug]/geral/alertas',
    SERVICE_REQUESTS: '/perfil-cidadao/empresas/[citizenSlug]/geral/encaminhamentos',
    CASE_FOLLOW_UPS: '/perfil-cidadao/empresas/[citizenSlug]/geral/acompanhamentos-de-caso',
    ASSESSMENTS: '/perfil-cidadao/empresas/[citizenSlug]/geral/avaliacoes',
    DOCUMENTS: '/perfil-cidadao/empresas/[citizenSlug]/geral/documentos',
    FILES: '/perfil-cidadao/empresas/[citizenSlug]/geral/arquivos',
    FAMILIES: '/perfil-cidadao/empresas/[citizenSlug]/geral/familias',
    TUTORS: '/perfil-cidadao/empresas/[citizenSlug]/geral/tutores',
    ACTIONS: '/perfil-cidadao/empresas/[citizenSlug]/geral/acoes',
  },
}

export const CITIZEN_PROFILE_EXTERNAL_ROUTES = {
  CITIZEN_PROFILE: `${CITIZEN_PROFILE_URL}/cidadaos/[citizenSlug]`,
  FAMILY_PROFILE: `${CITIZEN_PROFILE_URL}/familias/[familySlug]`,
}
